module.exports = __webpack_public_path__ + "img/JT-7-4-3-4-no12.93896d3d.jpg";